import { formatNumber } from "@nabla/api";

export { formatFrequency, formatNumber, formatPercent, formatRatio } from "@nabla/api";

export function plural(count: number, um: string, varios: string): string {
  return count === 1 ? um : varios;
}

export function formatCount(count: number, noun: { readonly um: string; readonly varios: string }): string {
  return `${formatNumber(count)} ${plural(count, noun.um, noun.varios)}`;
}

const exact = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 6 });
export const withoutFloatNoise = (value: number) => Number(value.toPrecision(12));
export const exactNumber = (value: number) => exact.format(withoutFloatNoise(value));
export const exactPercent = (fraction: number) => `${exactNumber(fraction * 100)}%`;

export function formatBytes(bytes: number): string {
  const mega = 1024 * 1024;
  if (bytes < mega) return `${formatNumber(Math.max(1, Math.round(bytes / 1024)))} KB`;
  return `${formatNumber(bytes / mega)} MB`;
}
